'use client';
import { cn } from '@/lib/utils';
import { Popover } from '@headlessui/react';
import React from 'react';

function Tooltip(props) {
  const { children, content, className } = props;
  const buttonRef = React.useRef(null);

  function handlePopoverEnter() {
    const btn = buttonRef.current;
    if (btn) {
      btn.click();
    }
  }

  function handlePopoverOut() {
    const btn = buttonRef.current;
    if (btn) {
      const isActive = btn.getAttribute('data-active') === 'true';
      if (isActive) {
        btn.click();
      }
    }
  }

  function handlePopoverClick() {
    const btn = buttonRef.current;
    if (btn) {
      const isActive = btn.getAttribute('data-active') === 'true';
      btn.setAttribute('data-active', isActive ? 'false' : 'true');
    }
  }

  return (
    <Popover className="relative inline-block select-none">
      <Popover.Button
        ref={buttonRef}
        className="flex items-center focus:outline-none"
        onClick={handlePopoverClick}
        onMouseEnter={handlePopoverEnter}
        onMouseLeave={handlePopoverOut}>
        {children}
      </Popover.Button>
      {content && (
        <Popover.Panel className="absolute left-1/2 !z-2000 -translate-x-1/2 transform">
          <div
            className={cn(
              '!z-2000 rounded-lg border bg-black p-2 font-dmsans text-14 text-white',
              className,
            )}>
            {content}
          </div>
        </Popover.Panel>
      )}
    </Popover>
  );
}

export default Tooltip;
